module.exports = __webpack_public_path__ + "static/img/prime_add.d4165c9d.svg";